// surveyStatusUtils.ts
import { SurveyStatus } from '../../redux/survey/survey.types';

export const displaySurveyStatus = {
  [SurveyStatus.Draft]: 'Draft',
  [SurveyStatus.Complete]: 'Complete',
  [SurveyStatus.Live]: 'Live',
  [SurveyStatus.Review]: 'In Review',
  [SurveyStatus.Rejected]: 'Rejected',
  [SurveyStatus.Building]: 'Building',
  [SurveyStatus.Retry]: 'Retrying',
  [SurveyStatus.Failed]: 'Failed',
};

export const computeColor = (surveyStatus: SurveyStatus | string) => {
  switch (surveyStatus) {
    case SurveyStatus.Draft:
      return { bg: 'bg-status-gray', text: 'text-status-gray' };
    case SurveyStatus.Complete:
      return { bg: 'bg-status-green', text: 'text-status-green' };
    case SurveyStatus.Live:
      return { bg: 'bg-blue-500', text: 'text-blue-500' };
    case SurveyStatus.Rejected:
      return { bg: 'bg-warning-1000', text: 'text-warning-1000' };
    case SurveyStatus.Review:
      return { bg: 'bg-purple-500', text: 'text-purple-500' };
    default:
      return { bg: 'bg-status-gray', text: 'text-status-gray' };
  }
};
